// extracted by mini-css-extract-plugin
module.exports = {"uploadwrap":"upload_uploadwrap__2Gtyj","item":"upload_item__3ArCk","overlay":"upload_overlay__3h9_E","img":"upload_img__32C-O","delBtn":"upload_delBtn__SoSlE"};